import { SyntheticEvent, useState } from 'react';
import { capitalize } from 'lodash';
import Form from 'react-bootstrap/Form';
import { atom, useRecoilState } from 'recoil';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import OverlayTrigger from 'components/common/OverlayTrigger/OverlayTrigger';
import CheckboxRadio from 'components/common/CheckboxRadio/CheckboxRadio';
import Button from 'components/common/Button/Button';
import * as K from 'common/constants';
import ELEMENT from 'common/element';

import './DistributionYScaleDropdown.scss';

export const distributionYScaleState = atom<K.Y_SCALE_OPTIONS>({
  key:     'distributionYScale',
  default: K.Y_SCALE_OPTIONS.LINEAR,
});

function DistributionYScaleDropdown(): JSX.Element {
  const [ distributionYScale, setDistributionYScale ] = useRecoilState(distributionYScaleState);
  const [ showOverlay, setShowOverlay ] = useState(false);

  const handleYScaleChange = (event: SyntheticEvent): void => {
    const { value } = event.target as HTMLInputElement;
    setDistributionYScale(value as K.Y_SCALE_OPTIONS);
  };

  const dropdownBody = (
    <div className="Dropdown__Menu">
      <div className="DistributionYScaleDropdown__body">
        <Form.Group className="DistributionYScaleDropdown__FormGroup">
          <Form.Label className="DistributionYScaleDropdown__formLabel">
            Y-Axis Scale
          </Form.Label>
          <div>
            <CheckboxRadio
              type="radio"
              name="yScaleLinear"
              label="Linear"
              onChange={handleYScaleChange}
              checked={distributionYScale === K.Y_SCALE_OPTIONS.LINEAR || !distributionYScale}
              value={K.Y_SCALE_OPTIONS.LINEAR}
              testId={ELEMENT.searchDistributionYScaleLinear}
            />
          </div>

          <div>
            <CheckboxRadio
              type="radio"
              name="yScaleLogarithmic"
              label="Logarithmic"
              onChange={handleYScaleChange}
              checked={distributionYScale === K.Y_SCALE_OPTIONS.LOGARITHMIC}
              value={K.Y_SCALE_OPTIONS.LOGARITHMIC}
              testId={ELEMENT.searchDistributionYScaleLogarithmic}
            />
          </div>
        </Form.Group>
      </div>
    </div>
  );

  const buttonLabel = distributionYScale || K.Y_SCALE_OPTIONS.LINEAR;
  const capitalizedButtonLabel = capitalize(buttonLabel);

  return (
    <div>
      <OverlayTrigger placement="bottom-end" overlay={dropdownBody} showOverlay={showOverlay} setShowOverlay={setShowOverlay}>
        <Button
          leftIcon={<TrendingUpIcon fontSize="small" />}
          rightIcon={<ArrowDropDownIcon fontSize="small" />}
          size="sm"
        >
          {capitalizedButtonLabel}
        </Button>
      </OverlayTrigger>
    </div>
  );
}

export default DistributionYScaleDropdown;
